export default "__VITE_ASSET__fc51ba4a__"